function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
// import VueDraggableNext from 'vue-draggable-next'
import DimensionCom from './components/DimensionCom.vue';
import { dataDatabaseFieldsApi } from '@/api/develop';
export default {
  name: 'setDimensional-editor',
  components: {
    DimensionCom: DimensionCom
  },
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  model: {
    prop: 'optionModel',
    // 默认是value
    event: 'optionModel' // 默认是input
  },
  data: function data() {
    return {
      selectedMetrics: '',
      selectedDimension: '',
      selectedDimensionRow: '',
      chartType: '',
      dimension: [],
      dimensionRow: [],
      dimensionCol: [],
      metrics: [],
      showFields: [],
      fields: [],
      loading: false,
      drawer: false,
      itemBoxHeight: '',
      needType: ['input_number', 'input_float', 'input_price', 'input_percentage', 'Percent', 'number', 'input_select', 'input', 'textarea', 'time_range', 'time', 'date_picker', 'date_time_picker', 'Reference', 'Boolean', 'Option', 'Status', 'tag', 'radio', 'checkbox', 'cascader_radio'],
      fieldsAdd: {
        alias: '',
        showEdit: false,
        editAlias: '',
        type: 'N',
        sort: '',
        calcMode: 'count',
        thousandsSeparator: false,
        showDecimalPlaces: false,
        decimalPlaces: 2,
        showNumericUnits: false,
        numericUnits: '无'
      }
    };
  },
  watch: {
    optionModel: {
      handler: function handler(newVal) {
        this.$emit('optionModelChange', newVal);
        this.initDimensional();
      },
      deep: true
    }
  },
  computed: {
    showChangeAlias: function showChangeAlias() {
      return this.selectedWidget.type == 'listTable';
    }
  },
  mounted: function mounted() {
    this.initDimensional();
  },
  methods: {
    // ...mapActions(['getEntityFields']),
    initDimensional: function initDimensional() {
      var _this = this;
      this.chartType = this.selectedWidget.type;
      this.dimension = this.optionModel.setDimensional.dimension || [];
      this.metrics = this.optionModel.setDimensional.metrics || [];
      this.showFields = this.optionModel.setDimensional.showFields || [];
      this.dimensionRow = this.optionModel.setDimensional.dimensionRow || [];
      this.dimensionCol = this.optionModel.setDimensional.dimensionCol || [];
      this.$nextTick(function () {
        _this.setItemBoxHeight();
      });
    },
    getEntityFields: function getEntityFields() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.loading = true;
              _context.next = 3;
              return dataDatabaseFieldsApi(_this2.optionModel.dataEntity);
            case 3:
              res = _context.sent;
              if (res && res.status === 200) {
                _this2.fields = [];
                res.data.forEach(function (el) {
                  if (_this2.needType.includes(el.form_value)) {
                    var newFieldsAdd = _objectSpread({}, _this2.fieldsAdd);
                    newFieldsAdd.alias = el.field_name;
                    newFieldsAdd.type = el.form_value;
                    var newField = Object.assign(newFieldsAdd, _objectSpread({}, el));
                    _this2.fields.push(_objectSpread({}, newField));
                  }
                });
                _this2.$nextTick(function () {
                  _this2.setItemBoxHeight();
                });
              }
              _this2.loading = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openDrawer: function openDrawer() {
      if (!this.optionModel.dataEntity) {
        this.$message.warning('请先选择图标数据实体');
        return;
      }
      this.drawer = true;
      this.getEntityFields();
    },
    onCancel: function onCancel() {
      // Your onCancel logic here
    },
    setItemBoxHeight: function setItemBoxHeight() {
      var formHeight = this.$refs.formBox && this.$refs.formBox.offsetHeight;
      if (formHeight) {
        formHeight += 60;
        this.itemBoxHeight = 'calc(100% - ' + formHeight + 'px)';
      } else {
        this.itemBoxHeight = 'calc(100% - 175px)';
      }
    },
    addCom: function addCom(e, target) {
      this.$refs.sortPopoverRefs.doClose();
      var i = this.fields.findIndex(function (el) {
        return el.field_name_en == e;
      });
      var cutField = _objectSpread({}, this.fields[i]);
      cutField.calcMode = 'sum';
      var checkHasDimensionRow = this.dimensionRow.filter(function (el) {
        return el.field_name == cutField.field_name;
      });
      var checkHasDimensionCol = this.dimensionCol.filter(function (el) {
        return el.field_name == cutField.field_name;
      });
      var checkHasDimension = this.dimension.filter(function (el) {
        return el.field_name == cutField.field_name;
      });
      var checkHasMetrics = this.metrics.filter(function (el) {
        return el.field_name == cutField.field_name;
      });
      var checkHasShowFields = this.showFields.filter(function (el) {
        return el.field_name == cutField.field_name;
      });
      if (checkHasDimension.length > 0) {
        this.$message.warning('添加失败，同一字段不能重复添加维度');
        return;
      }
      if (checkHasDimensionRow.length > 0) {
        this.$message.warning('添加失败，同一字段不能重复添加维度行');
        return;
      }
      if (checkHasDimensionCol.length > 0) {
        this.$message.warning('添加失败，同一字段不能重复添加维度列');
        return;
      }
      if (checkHasMetrics.length > 0) {
        this.$message.warning('添加失败，同一字段不能重复添加指标');
        return;
      }
      if (checkHasShowFields.length > 0) {
        this.$message.warning('添加失败，同一字段不能重复添加显示字段');
        return;
      }
      var dimensionLength = this.dimension.length;
      var metricsLength = this.metrics.length;
      var type = this.selectedWidget.type;
      var max3 = ['barChart', 'barXChart', 'lineChart', 'radarChart'];
      // 添加维度
      if (target == 'dimension') {
        // 1个维度或多个指标
        // 2个维度或1个指标
        if (max3.includes(type)) {
          if (dimensionLength > 1) {
            this.$message.warning('添加失败，最多添加2个维度');
            return;
          }
          if (metricsLength > 1 && dimensionLength > 0) {
            this.$message.warning('添加失败，多个指标最多只能添加1个维度');
            return;
          }
        }
        // 如果是饼图、漏斗图 最多添加1个维度
        if ((type == 'pieChart' || type == 'funnelChart') && dimensionLength > 0) {
          this.$message.warning('添加失败，最多添加1个维度');
          return;
        }
        this.dimension.push(cutField);
      }
      // 添加指标
      else if (target == 'metrics') {
        // 1个维度或多个指标
        // 2个维度或1个指标
        if (max3.includes(type)) {
          if (dimensionLength > 1 && metricsLength > 0) {
            this.$message.warning('添加失败，2个维度最多只能添加1个指标');
            return;
          }
        }
        // 如果是饼图、进度条 最多添加1个指标
        if ((type == 'pieChart' || type == 'progressbar' || type == 'statistic') && metricsLength > 0) {
          this.$message.warning('添加失败，最多添加1个指标');
          return;
        }
        this.metrics.push(cutField);
      }
      // 添加显示字段
      else if (target == 'showFields') {
        this.showFields.push(cutField);
      }
      // 添加维度行
      else if (target == 'dimensionRow') {
        this.dimensionRow.push(cutField);
      }
      // 添加维度列
      else if (target == 'dimensionCol') {
        this.dimensionCol.push(cutField);
      }
    },
    onSort: function onSort(e) {
      this.dimension.forEach(function (el) {
        el.sort = '';
      });
      this.dimensionRow.forEach(function (el) {
        el.sort = '';
      });
      this.dimensionCol.forEach(function (el) {
        el.sort = '';
      });
      this.metrics.forEach(function (el) {
        el.sort = '';
      });
      this.showFields.forEach(function (el) {
        el.sort = '';
      });
      e.tag.sort = e.target;
    },
    isShowDimension: function isShowDimension() {
      var notNeedDimension = ['progressbar', 'listTable', 'pivotTable', 'statistic'];
      return this.showFn(notNeedDimension);
    },
    showFn: function showFn(notNeed) {
      if (notNeed.includes(this.chartType)) {
        return false;
      }
      return true;
    }
  }
};